import React, { useState } from "react";
import { StringWithFormat } from "../../types/Result";
import { useTranslations } from "./../../contexts/translationContext";

export interface TitleProps {
text?: string|StringWithFormat,
size: 1|2|3|4|5|6
}

const Title: React.FC<TitleProps> = ({ text, size }) => {
    const [title, setTitle] = useState<string>('');
    const { translate } = useTranslations();

    if (text) {
        if (typeof text === 'string') {
            translate('Title.' + text, undefined, text).then(translated => setTitle(translated));
        } else {
            translate('Title.' + text.format, undefined, text).then(translated => setTitle(translated));
        }
    }

    const headerStyle: React.CSSProperties = { margin: '10px 0 0' };
    const dividerStyle: React.CSSProperties = { width: '10%', height: 5, margin: '0 10px 15px 0', backgroundColor: '#23ccef', display: 'block' };

    switch (size) {
        case 1: return <><h1 style={headerStyle}>{title}</h1><div style={dividerStyle} /></>;
        case 2: return <><h2 style={headerStyle}>{title}</h2><div style={dividerStyle} /></>;
        case 3: return <><h3 style={headerStyle}>{title}</h3><div style={dividerStyle} /></>;
        case 4: return <><h4 style={headerStyle}>{title}</h4><div style={dividerStyle} /></>;
        case 5: return <><h5 style={headerStyle}>{title}</h5><div style={dividerStyle} /></>;
        case 6: return <><h6 style={headerStyle}>{title}</h6><div style={dividerStyle} /></>;

        default:
            return <></>
    }

}

export default Title;